import { tv } from 'tailwind-variants';

export const dropdownStyle = tv({
  base: 'absolute bg-white border border-gray-200 rounded-lg overflow-hidden shadow z-[99] ease-[cubic-bezier(0.215, 0.61, 0.355, 1)] transition-all duration-200 p-2',
  variants: {
    position: {
      top: 'bottom-full left-0 mb-1',
      center:
        '-top-2.5 left-1/2 -translate-x-1/2 -translate-y-full before:-bottom-1  before:left-1/2 before:-translate-x-1/2',
      bottom: 'top-full translate-y-2 before:-top-1 before:right-2.5',
      left: '-left-2 top-1/2 -translate-y-1/2 -translate-x-full before:-right-1 before:top-1/2 before:-translate-y-1/2',
      right:
        '-right-2 top-1/2 -translate-y-1/2 translate-x-full before:-left-1 before:top-1/2 before:-translate-y-1/2',
      'top-left':
        '-top-2.5 left-6 -translate-y-full -translate-x-full before:-bottom-1 before:right-2.5',
      'top-right':
        '-top-2.5 right-6 -translate-y-full translate-x-full before:-bottom-1 before:left-2.5',
      'bottom-left': 'translate-y-2 right-0 before:-top-1 before:right-2.5',
      'bottom-right': 'translate-y-4 left-1 before:-top-1 before:left-2.5',
    },
    design: {
      europeAssistance: '',
      default: '',
    },
    isOpened: {
      true: 'min-w-max opacity-100 visible',
      false: 'transition-all duration-0 min-w-0 invisible opacity-0',
    },
  },
  defaultVariants: {
    design: 'default',
    position: 'bottom',
    isOpened: false,
  },
});
